export function filterInventoryItems(items, searchStr) {
    if (items){
        items.forEach((item)=>{
            item.applyFilter(searchStr);
        })
    }
}
